import React, { Component } from 'react'
import { source } from 'react-aim';
import { Button, Popup } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
// import "./Toolbar.css";
const _ = require('lodash');


class ToolbarCustomTemplate extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	}
	createTemplate = (e) => {
		dispatch.customTemplates.setCustomNotificationRuleName(null);
        dispatch.customTemplates.setCustomNotificationCondition(null);
		const { history } = this.props;
		history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_wsSetting/emailTemplates/email/new`);
	}
	render() {
		return (
			<div className="toolBar header_buttons toolbatInputFile">

				<Button.Group size='mini' className="mar_Right_5" >
					<Popup className="popupStyled" 
                        inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Create Template")}><Button icon='plus' 
                        className="clr-green" onClick={this.createTemplate} /></span>}
						content='Create Template'
					/>
				</Button.Group>
			</div >
		)
	}
}

export default ToolbarCustomTemplate